import { FETCH_ONBOARDING_SETTINGS, FETCH_ONBOARDING_SETTINGS_FAILED, FETCH_ONBOARDING_SETTINGS_SUCCESS, HIDE_LOADING_INDICATOR, SAVE_ONBOARDING_SETTINGS, SAVE_ONBOARDING_SETTINGS_FAILED, SAVE_ONBOARDING_SETTINGS_SUCCESS, SHOW_LOADING_INDICATOR, SHOW_CONFIRMATION, HIDE_CONFIRMATION } from './actionTypes';

export const fetchOnboardingSettings = () => ({
    type: FETCH_ONBOARDING_SETTINGS,
    payload: {}
})

export const fetchOnboardingSettingsSuccess = (onboardingSettings) => ({
    type: FETCH_ONBOARDING_SETTINGS_SUCCESS,
    payload: onboardingSettings
})

export const fetchOnboardingSettingsFailed = (error) => ({
    type: FETCH_ONBOARDING_SETTINGS_FAILED,
    payload: error
})

export const saveOnboardingSettings = (onboardingSettings) => ({
    type: SAVE_ONBOARDING_SETTINGS,
    payload: onboardingSettings
})

export const saveOnboardingSettingsSuccess = () => ({
    type: SAVE_ONBOARDING_SETTINGS_SUCCESS,
    payload: {}
})

export const saveOnboardingSettingsFailed = (error) => ({
    type: SAVE_ONBOARDING_SETTINGS_FAILED,
    payload: error
})

export const showLoadingIndicator = () => ({
    type: SHOW_LOADING_INDICATOR,
    payload: {}
})

export const hideLoadingIndicator = () => ({
    type: HIDE_LOADING_INDICATOR,
    payload: {}
})

export const showConfirmation = () => ({
    type: SHOW_CONFIRMATION,
    payload: {}
})

export const hideConfirmation = () => ({
    type: HIDE_CONFIRMATION,
    payload: {}
})